<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <router-link :to="{ path: '/alarm/add', query: { guid: params.guid } }">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            class="handle-del mr10"
            v-if="$route.query.dtid"
            >添加</el-button
          >
        </router-link>
        <router-link :to="{ path: '/dev/list' }">
          <el-button size="small" type="primary" class="handle-del mr10"
            >设备列表</el-button
          >
        </router-link>
      </div>

      <el-table
        :data="tableData"
        stripe
        @selection-change="checkIds"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="65"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="aid"
          v-if="false"
          label="ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="alarm_name"
          label="报警名"
          align="center"
        ></el-table-column>
        <el-table-column prop="var_name" label="设备变量" align="center">
          <div slot-scope="scope" v-if="scope.row.var_name">
            {{ scope.row.var_name }}[{{ scope.row.var_code }}]
          </div>
          <div v-else>---</div>
        </el-table-column>
        <el-table-column prop="var_type" label="变量类型" align="center">
          <div slot-scope="scope" v-if="scope.row.var_name">
            <span v-if="scope.row.var_type === '0'">开关型</span>
            <span v-if="scope.row.var_type === '1'">模拟型</span>
            <span v-if="scope.row.var_type === '2'">时间型</span>
            <span v-if="scope.row.var_type === '3'">位变量</span>
          </div>
          <div v-else>---</div>
        </el-table-column>
        <el-table-column
          prop="alarm_rule"
          label="报警规则"
          align="center"
        ></el-table-column>
        <!--<el-table-column prop="alarmcontent" label="报警内容" :show-overflow-tooltip="true" width="120" align="center"> </el-table-column>-->
        <!-- <el-table-column prop="alarm_inform" label="通知方式" align="center">
          <div slot-scope="scope">
            <span v-if="scope.row.alarm_inform">{{
              handleAlarmInfo(scope.row.alarm_inform)
            }}</span>
          </div>
        </el-table-column> -->
        <el-table-column prop="name" label="操作" align="center">
          <div slot-scope="scope">
            <router-link
              :to="{ path: '/alarm/update', query: { id: scope.row.aid,guid:scope.row.guid } }"
            >
              <el-button
                class="ml10"
                type="text"
                icon="el-icon-edit"
                v-if="isShow(scope.row)"
                >修改</el-button
              >
              <el-button
                class="ml10"
                type="text"
                icon="el-icon-edit"
                v-else
                >详情</el-button
              >
            </router-link>

            <el-button
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              @click="del('Alarm/Delete', scope.row.aid)"
              v-if="isShow(scope.row)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>

      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
            size="small"
            :disabled="disabled"
            @click="deleteBatch('Alarm/Delete', ids)"
            >批量删除</el-button
          >
        </div>
        <!-- 分页组件 -->

        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import listMixins from "@/mixins/list";

export default {
  name: "Alarm",
  mixins: [listMixins],
  data() {
    return {
      params: {
        //只需要业务参数
        id: "",
        pageNo: "1",
        pageSize: "10"
      },
      vars: [],
      isadmin: false
    };
  },
  mounted() {},
  methods: {
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].aid);
      }
      this.ids = ids.join(",");
      this.disabled = val.length > 0 ? false : true;
    },
    del(val1, val2) {
      this.deleteBatch(val1, val2);
    },
    handleAlarmInfo(alarminfo) {
      if (alarminfo) {
        return alarminfo
          .replace("0", "短信")
          .replace("1", "语音")
          .replace("2", "短信+语音");
      }
    },
    isShow(row){
      if(this.$route.query.dtid)//从设备类型界面调过来
      {return false}
      
      return true
    }
  },
  created() {
    this.params.guid = this.$route.query.guid;
    this.initTableData("Alarm/PagedView", this.params);
    this.isadmin = this.$isAdmin();
  },
  watch: {
    // 修复增改之后，重新加载页面，无法执行 created  函数
    $route(to, from) {
      if(to.fullPath.indexOf('/alarm/list')===-1)
      {
        return;
      }
      this.params.guid = this.$route.query.guid;
      this.initTableData("Alarm/PagedView", this.params);
      this.isadmin = this.$isAdmin();
    }
  }
};
</script>
